const initialState = {
  asset_type: '',
  video_type: '',
  audio_type: null,
  source_asset_id: '',
  preview: '',
  title: '',
  description: '',
  artists: [],
  venues: [],
  live_comments_applicable: false,
  release_time: '',
  poster: {},
  category: '',
  sub_categories: '',
  search_tags: [],
  custom_metadata: {},
  is_geo_block_enabled: false,
  geo_block_countries: [],
  owner: [],
  serial_no: 0,
  parent: '',
  is_live: false,
  review_count: 0,
  average_rating: 0.0,
  playlist_data: {},
  // is_restricted: true,
  // pricing_model: [],
  // active_subscription: [],
  // active_ppv: [],
  //   publish_policy: '',
  //   release_time: null,
  //   expiry_date: null,
}

export const contentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EDIT_VALUES':
      return {
        ...state,
        ...action.payload,
      }
    case 'ASSET':
      return {
        ...state,
        asset_type: action.payload.assetType,
        video_type: action.payload.videoType,
      }
    case 'IPTV_ASSET':
      return {
        ...state,
        iptv_content_type: action.payload.iptvType,
      }
    // case 'UPLOAD_TRAILER':
    //   return {
    //     ...state,

    //   }
    case 'UPLOAD':
      return {
        ...state,
        preview: action.payload.trailerAssetId,
        source_asset_id: action.payload.sourceAssetId,
      }
    case 'SET_STREAM':
      return {
        ...state,
        stream: action.payload.liveStream,
        preview: action.payload.trailerAssetId,
        source_asset_id: '',
        is_live: true,
      }
    case 'CONTENT_DETAILS':
      return {
        ...state,
        title: action.payload.title,
        description: action.payload.description,
        category: action.payload.category,
        sub_categories: action.payload.subCategories,
        artists: action.payload.artists,
        venues: action.payload.venues,
        live_comments_applicable: action.payload.liveComments,
        thumbnail: action.payload.thumbnail,
        poster: action.payload.poster,
        parent: action.payload.parentContent,
        serial_no: action.payload.episodeNo,
      }
    case 'PLAYLIST':
      return {
        ...state,
        playlist_data: action.payload.playlistData,
        category: action.payload.category,
        sub_categories: action.payload.subCategories,
        artists: action.payload.artists,
        venues: action.payload.venues,
        preview: '',
        source_asset_id: '',
      }
    case 'ADVANCE_SETTING':
      return {
        ...state,
        search_tags: action.payload.tags,
        content_rating: action.payload.rating,
        custom_metadata: action.payload.customMetadata,
        is_geo_block_enabled: action.payload.geoBlocking,
        geo_block_countries: action.payload.geoBlockCountries,
        owner: action.payload.owner,
        release_time: action.payload.release_time ? action.payload.release_time : null,
      }
    // case 'PRICING':
    //   return {
    //     ...state,
    //     is_restricted: action.payload.isRestricted,
    //     pricing_model: action.payload.pricingModel,
    //     active_subscription: action.payload.subscriptions,
    //     active_ppv: action.payload.ppv,
    //   }
    // case 'PUBLISH':
    //   return {
    //     ...state,
    //     publish_policy: action.payload.isRestricted,
    //     publish_date: action.payload.publish_date,
    //     expiry_date: action.payload.subscriptions,
    //   }
    case 'EMPTY_CONTENT':
      return {
        ...state,
        asset_type: '',
        video_type: '',
        audio_type: '',
        source_asset_id: '',
        title: '',
        description: '',
        artists: [],
        venues: [],
        thumbnail: {},
        poster: {},
        category: '',
        sub_categories: '',
        search_tags: [],
        custom_metadata: {},
        is_geo_block_enabled: false,
        geo_block_countries: [],
        is_restricted: true,
        pricing_model: [],
        active_subscription: [],
        owner: [],
      }
    default:
      return state
  }
}
